
import React from 'react';
import { CheckCircle, ExternalLink } from 'lucide-react';

interface TransactionProcessingInfoProps {
  isKeepMoreTransaction: boolean;
}

const TransactionProcessingInfo: React.FC<TransactionProcessingInfoProps> = ({ isKeepMoreTransaction }) => {
  return (
    <div>
      <h3 className="text-sm font-medium text-muted-foreground mb-1">Processed with</h3>
      {isKeepMoreTransaction ? (
        <div className="flex items-center text-green-700">
          <CheckCircle className="h-4 w-4 mr-1" />
          <span>KeepMore</span>
        </div>
      ) : (
        <div className="flex items-center text-muted-foreground">
          <ExternalLink className="h-4 w-4 mr-1" />
          <span>Direct Stripe</span>
        </div>
      )}
    </div>
  );
};

export default TransactionProcessingInfo;
